import Vue from 'vue'
import VuePhoneNumberInput from 'vue-phone-number-input'
import 'vue-phone-number-input/dist/vue-phone-number-input.css'

// A lib só busca país por nome (regex letras-only no método original).
// Sobrescrevemos aqui pra também buscar pelo DDI, sem precisar editar
// node_modules (o patch é perdido em cada npm install).
const CountrySelector = VuePhoneNumberInput.components?.CountrySelector

if (CountrySelector?.methods?.searching) {
  CountrySelector.methods.searching = function (e) {
    const code = e.keyCode
    clearTimeout(this.queryTimer)
    this.queryTimer = setTimeout(() => {
      this.query = ''
    }, 1000)

    const q = String.fromCharCode(code)

    if (code === 8 && this.query !== '') {
      this.query = this.query.substring(0, this.query.length - 1)
      return
    }

    if (!/[a-zA-Z0-9\- ]/.test(q)) {
      return
    }

    if (!this.hasListOpen) this.openList()
    this.query += e.key

    const searchingByDialCode = /^\d+$/.test(this.query)
    const countries = this.preferredCountries
      ? this.countriesSorted.slice(this.preferredCountries.length)
      : this.countriesSorted

    const resultIndex = countries.findIndex((c) => {
      this.tmpValue = c.iso2
      return searchingByDialCode
        ? String(c.dialCode).startsWith(this.query)
        : c.name.toLowerCase().startsWith(this.query)
    })

    if (resultIndex !== -1) {
      this.scrollToSelectedOnFocus(
        resultIndex + (this.preferredCountries ? this.preferredCountries.length : 0)
      )
    }
  }
}

Vue.component('PhoneNumber', VuePhoneNumberInput)
